import React from 'react';
import { HotelRatingSquare } from '@lt/components';
import classnames from 'classnames';

import styles from './ratingBadge.module.css';

export interface RatingBadgeProps {
  value: number | null;
  isMobile: boolean;
}

const RatingBadge = ({ isMobile, value }: RatingBadgeProps) => (
  <HotelRatingSquare
    className={classnames(styles.hotelRating, {
      [styles.hotelRatingLeft]: !isMobile,
      [styles.hotelRatingRight]: isMobile,
    })}
    showMeta={false}
    value={value}
    count={value}
  />
);

export default RatingBadge;
